var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C8.51067 0.5 5.67188 3.22524 5.67188 6.575C5.67188 9.92476 8.51067 12.65 12 12.65C15.4893 12.65 18.3281 9.92476 18.3281 6.575C18.3281 3.22524 15.4893 0.5 12 0.5ZM12 11.3C9.28608 11.3 7.07812 9.18037 7.07812 6.575C7.07812 3.96964 9.28608 1.85 12 1.85C14.7139 1.85 16.9219 3.96964 16.9219 6.575C16.9219 9.18037 14.7139 11.3 12 11.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9609 14.045H10.039C6.79519 14.045 3.59386 15.4828 1.45312 18.5656V23.54H22.5469V18.5656C20.4092 15.4873 17.2088 14.045 13.9609 14.045ZM21.1407 22.19H21.1406H2.85938V18.9787C4.50145 16.7307 7.16963 15.395 10.0391 15.395H13.961C16.8304 15.395 19.4985 16.7307 21.1407 18.9787V22.19Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e91b95be.svg";
export { ForwardRef as ReactComponent };